
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.914 44c-3.577-5.19-7.151-10.335-10.977-15.337-3.37-4.407-6.867-9.158-6.867-15.022C6.07 8.772 8.858 4 14.084 4c3.976 0 7.436 2.962 8.358 6.87.638 2.706 2.326 2.742 3.082.001 1.104-4 4.15-6.836 8.322-6.836 5.325 0 8.084 4.699 8.084 9.676 0 5.81-3.616 10.762-6.987 15.11C31.106 33.77 27.503 38.865 23.914 44","fill":"#535353"}})])
          )
        }
      }
    